module.exports = {"title":"Neočakávaná chyba","action":"Prosím obnovte Gnosus aplikáciu","button":"Obnoviť"}